import { Echelon } from '../../../../common/models/echelon.js'
import * as TerrassorConst from '../../../../terrassor_const.js'

import { set_Terrassor_INTERFACE, get_Terrassor_INTERFACE } from "../../../../interface.js";



/* @ngInject */
export class MouvementController {
  /* @ngInject */
  constructor (ApiConst, ApiSimu, ApiExo, $scope, $q) {
    this.$scope = $scope
    this.$q = $q
    this.ApiConst = ApiConst
    this.ApiSimu = ApiSimu
    this.ApiExo = ApiExo

    //méthodes appelées par les composants enfants ex : <add-engin> 
    this.addEchelon = this.addEchelon.bind(this)
    this.refreshEchelon = this.refreshEchelon.bind(this)
    this.removeEchelon = this.removeEchelon.bind(this)
    this.onResourceChange = this.onResourceChange.bind(this)
    this.doOnChangeMouvement = this.doOnChangeMouvement.bind(this)

    // pour contourner les bindings inutiles sur <add-engin> // a terme on devrait remplacer le binding par l'héritage "require"
    this.ignore = this.ignore.bind(this) 

    // trigger sur le changement de mouvement (ici code-mouvement : "M01", "M02", etc)
    this.watcher = this.$scope.$watch('MouvementController.resource', this.onResourceChange)
  }


  $onInit () {

    console.log('MouvementController : init')
    //console.log('MouvementController --> require ^^simulator', this.parentSimulator)

    this.consigne = 'texte de consigne'
    this.warning = 'texte de warning'

    // on a bindé simplement le code du mouvement
    var resourceCode = this.resource

    this.codemouvement = this.resource

    // checkbox "mouvement valide pour la simulation"
    this.valid = 0

    // checkbox "mouvement commencé"
    this.started = 0

    // visibilité de la checkbox "commence"
    this.debug = TerrassorConst.MODE_DEBUG


    this.prepareInitialData(resourceCode)

    this.descriptionMouvement = null

  }

/*
* Pour les bindings inutiles sur <add-engin>
*/
  ignore(obj) { console.log('MouvementController::ignore', obj)  }

/*
* appelée par <add-engin> une fois que les engins ont été enregistrés (aussi par <edit-echelon>)
*/
  refreshEchelon(echelon)
  {
    console.log('MouvementController::refreshEchelon for', echelon)
    this.echelons.push(echelon)
    // se repositionner sur cet échelon (utile quand l'ajout d'engin a été réalisé dans l'onglet "nouvel echelon")
    this.setCurrentOnglet(this.echelons.length)
    // si on a raffraichi, c'est qu'il y a eu une modif de l'échelon, donc il faut invalider le mvt couirant
    return this.doOnChangeMouvement() 
  }

/* Envoi d'une notification au composant <tabcontainer>
*/
  setCurrentOnglet(index) {
    this.$scope.$broadcast('CURRENT_TAB_CHANGE', { newIndex: index })
    this.currentOnglet = index // Inutile 
  }

/*  checkbox "mouvement valide pour la simulation"
* Màj du mvt dans la base et vérif si tous les mouvements sont validés pour afficher / maquer le panel <animation>
*/
  doOnCheckValid(forceValue) {
    if(!this.currentMouvement)
      return

    if(forceValue !== undefined) // can bue true | false
      this.valid = forceValue
    
    var selected = this.valid

    this.currentSimuMouvement.valide = selected ? 1 : 0
    return this.ApiSimu.saveMouvement(this.currentSimuMouvement)
    .then( _ => {
      this.parentSimulator.checkAllMouvementsValid()  // on pourrait aller plus vite si selected == false ...
    })

  }

doOnMagicMouvement() {

    console.log('doOnMagicMouvement ', this.resource)

    this.setCurrentOnglet(0)
    this.prepareInitialData(this.resource)
  }

/*   doOnCheckStarted(forceValue) {
    if(!this.currentMouvement)
      return

    if(forceValue !== undefined) // can bue true | false
      this.started = forceValue
    
    var selected = this.started

    this.currentSimuMouvement.commence = selected ? 1 : 0
    return this.ApiSimu.saveMouvement(this.currentSimuMouvement)
    .then( _ => {
      this.parentSimulator.checkAllMouvementsValid()  // on pourrait aller plus vite si selected == false ...
    })

  }*/


  /*
*/
doOnChangeMouvement() {

    // BC 09/2017 - update de la date : si on fait la moindre modif sur le mouvement, on n'accepte pas qu'elle soit antérieure à la date courante !!!!! Sinon on vient d'inventer le voyage dans le temps :)
    this.imposerDatesEnCoherence()


      // BC il y a une modif donc on le dit au backend
  var retour =  get_Terrassor_INTERFACE().action({"table":"simu_analyses", "topDateEtude":[]})
  this.ApiSimu.saveAnalyse(retour.objet)

  this.valid = false // checkbox dans la vue
  get_Terrassor_INTERFACE().etude.simu_reel = false
  // simule le click sur le check "valid" (pour invalider suite à une modification)
  this.doOnCheckValid(false)
  
  // update de la consigne 
  this.defineConsigneEchelons()

}

/* lors d'une modification de mouvement : si la simu est commencée, le mouvement doit être planifié après la date courante */
imposerDatesEnCoherence() {
    var dateMin =  get_Terrassor_INTERFACE().action({"table":"simu_etudes", "dateMin":this.parentSimulator.nbJoursAtteints})
    if (this.currentSimuMouvement.debut < dateMin.objet) {
        /*this.currentSimuMouvement.debut = dateMin.objet
        this.currentMouvement.simuMouvement.debut = dateMin.objet*/
        if (this.descriptionMouvement) {
            this.descriptionMouvement.changeBeginningDate(dateMin.objet)
            this.descriptionMouvement.formatPrevisionnelMouvement()  // BC je le mets là ... le pb c que quand on modifie un echelon, on ne réaffiche pas le prévisionnel :(
        }
    }
}

  /*
  * Sélection d'un mouvement par son code (ex. depuis le schema des cubatures)
  * se placer sur le premier onglet <description-mouvement>
  */

  onResourceChange (newResourceCode, oldResourceCode) {
    console.log('MouvementController::$onResourceChange ', newResourceCode)
    if(newResourceCode === oldResourceCode)
      return

    this.setCurrentOnglet(0)

    this.prepareInitialData(newResourceCode)

  }


/**
* Updater la consigne au changement de mouvement
*/
  forceMessageMouvement() {
    this.parentSimulator.messageMouvement = null
    this.parentSimulator.dispatchTerrassorMessages()
  }

  /*
  * Lecture des infos du mouvement (ou création du simu_mouvement si premier accès )
  */
  prepareInitialData (newResourceCode) {
    console.log('MouvementController::prepareInitialData')

    this.echelons = []
    var mouvementToCreate = false

    //console.log('MouvementController::prepareInitialData ', newResourceCode)
    // lecture du mouvement courant (exo)
    this.ApiExo.getMouvementByCode(newResourceCode)
    .then(exo_mouvement => {
      this.currentExoMouvement = exo_mouvement
      if(!exo_mouvement) {
        console.log('MouvementController::currentExoMouvement not found ine DB', newResourceCode)
        return Promise.reject(newResourceCode)
        }
       return this.$q.resolve(exo_mouvement)
     })
    // ... puis, lecture du mouvement en cours d'etude (simu)
    .then( _ => {
    if(this.currentExoMouvement)
      // c'est une nouvelle requete, donc on retourne la Promise
      return this.ApiSimu.getMouvementByExoMouvementId(this.currentExoMouvement.id)
    else
      return null
    })

    // ... puis, test si le mvt obtenu existe
    .then(simu_mouvement => {
    this.currentSimuMouvement = simu_mouvement // can be null
    if(!this.currentSimuMouvement && this.currentExoMouvement) {
      // non, on le crée, nouvelle requete, donc on retourne une Promise
      mouvementToCreate = true
      return this.ApiSimu.createMouvement(this.currentExoMouvement.id)
      }
    else  {
      return this.$q.resolve(simu_mouvement)
      }
    })

    // lire les echelons de ce mouvement, passer l'info "mouvement valide" à la vue
    .then( simu_mouvement => {
        this.currentSimuMouvement = simu_mouvement
        this.currentMouvement = {'exoMouvement':this.currentExoMouvement, 'simuMouvement':this.currentSimuMouvement}
        this.valid = simu_mouvement.valide ? true : false
        this.started = simu_mouvement.commence ? true : false
        //this.started = false
        this.parentSimulator.currentMouvementStarted = this.started
        this.parentSimulator.desinhiberMouvementNotStarted()
        this.forceMessageMouvement()
        return this.ApiSimu.getEchelons(this.currentSimuMouvement.id)
      })
    .then(echelons => {
      console.log('MouvementController::prepareInitialData, echelons', echelons)

      this.echelons = echelons
   
      this.defineConsigneEchelons()
      return this.echelons
    })
  }


  /*
  * Ajout d'un nouvel echelon (fonction appelée par <add-engin>)
  */
  addEchelon() {
    //console.log('MouvementController::addEchelon, currentMouvement', this.currentMouvement)

    return this.ApiSimu.createEchelon(this.currentMouvement.simuMouvement)
    .then(newEchelon => {
      console.log('MouvementController::addEchelon done', newEchelon)
      // on n'ajoute pas encore cet echelon à this.echelons[] car ses engins ne sont pas encore sauvés
      //this.echelons.push(newEchelon)
      return newEchelon
    })
  }

  removeEchelon(echelon) {
    //console.log('MouvementController::removeEchelon ', echelon)

    return this.ApiSimu.deleteEchelon(echelon)
    .then(_ => {
      console.log('MouvementController::removeEchelon done', this.echelons)
      // remove object by value in array
      var index = this.echelons.indexOf(echelon) 
      this.echelons.splice(index, 1)

      this.setCurrentOnglet(this.echelons.length+1)
      return this.echelons.length
    })
  }

  // consignes du panel mouvement.  msg si : pas d'échelon créé  - nb max d'échelons atteint
  defineConsigneEchelons () {

    if(!(this.currentMouvement.simuMouvement.debut || this.currentMouvement.simuMouvement.fin)) {
      msg = 'Commencez par entrer les dates de début et fin de ce mouvement'
      this.consigne= msg
      return msg
    }

    var N = this.echelons.length
    console.log('defineConsigneEchelons, nb echelons : ', N)
    var msg = ''
    if (N == 0) msg = 'Veuillez ajouter des engins'
    if (N >= TerrassorConst.NB_ECHELONS_MAX) { // warning
      msg = 'Vous avez atteint la limite de ' + TerrassorConst.NB_ECHELONS_MAX + ' échelons par mouvement'
    }
    this.consigne= msg
    return msg
  }

  removeConsigneEchelons () {
    this.consigne = ''
  }

  getConsigneEchelons() {
    return this.consigne
  }

  // a-t'on attein le nb max d'échelons ?
  hasReachedLimit () {
    return this.echelons.length >= TerrassorConst.NB_ECHELONS_MAX
  }
}



// WEBPACK FOOTER //
// ./src/client/pages/simulator/components/mouvement/mouvement.controller.js